import { NgModule } from "@angular/core";
import { TicketsService } from "./services/tickets.service";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { TicketsGatewayService } from "./services/tickets-gateway.service";
import { AuthUtil } from "src/app/data/utils/auth.utils";
import { TicketsSharedService } from "./services/tickets-shared.service";

@NgModule({
  providers: [
    TicketsService,
    TicketsGatewayService,
    TicketsSharedService,
    AuthUtil,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    },
  ],
})
export class TicketsModule { }